"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AccordionTimelineMarker;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _hooks = require("../../libs/hooks");

var _context = require("../ActivityTimeline/context");

var _calendarIcon = _interopRequireDefault(require("./calendarIcon"));

var _li = _interopRequireDefault(require("./styled/li"));

var _columnLeft = _interopRequireDefault(require("./styled/columnLeft"));

var _iconContainer = _interopRequireDefault(require("./styled/iconContainer"));

var _contentContainer = _interopRequireDefault(require("./styled/contentContainer"));

var _header = _interopRequireDefault(require("./styled/header"));

var _label = _interopRequireDefault(require("./styled/label"));

var _datetime = _interopRequireDefault(require("./styled/datetime"));

var _description = _interopRequireDefault(require("./styled/description"));

var _body = _interopRequireDefault(require("./styled/body"));

var _expandCollapseButton = _interopRequireDefault(require("./expandCollapseButton"));

var _removeItemFromArray = _interopRequireDefault(require("../AccordionSection/removeItemFromArray"));

var _isInArray = _interopRequireDefault(require("../AccordionSection/isInArray"));

function AccordionTimelineMarker(props) {
  var icon = props.icon,
      name = props.name,
      isLoading = props.isLoading,
      label = props.label,
      description = props.description,
      datetime = props.datetime,
      children = props.children,
      className = props.className,
      style = props.style;

  var _useContext = (0, _react.useContext)(_context.ActivityTimelineContext),
      activeNames = _useContext.activeNames,
      multiple = _useContext.multiple,
      privateRegisterMarker = _useContext.privateRegisterMarker,
      privateUnregisterMarker = _useContext.privateUnregisterMarker,
      privateOnToggleMarker = _useContext.privateOnToggleMarker;

  var generatedName = (0, _hooks.useUniqueIdentifier)('timeline-marker');
  var currentName = (0, _react.useMemo)(function () {
    return name || generatedName;
  }, [generatedName, name]);
  var stepRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    privateRegisterMarker(stepRef.current, {
      currentName: currentName
    });
    return function () {
      privateUnregisterMarker(stepRef, currentName);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var resolveActiveNamesWhenMultiple = (0, _react.useCallback)(function () {
    if (activeNames === undefined) {
      return [currentName];
    }

    if ((0, _isInArray["default"])(activeNames, currentName)) {
      return (0, _removeItemFromArray["default"])(activeNames, currentName);
    }

    return activeNames.concat([currentName]);
  }, [currentName, activeNames]);
  var resolveActiveNames = (0, _react.useCallback)(function () {
    if (multiple) {
      return resolveActiveNamesWhenMultiple();
    }

    if (currentName === activeNames) {
      return '';
    }

    return currentName;
  }, [currentName, multiple, activeNames, resolveActiveNamesWhenMultiple]);
  var handleToggleMarker = (0, _react.useCallback)(function () {
    return privateOnToggleMarker({
      activeSectionNames: resolveActiveNames(),
      toggledSection: currentName
    });
  }, [currentName, privateOnToggleMarker, resolveActiveNames]);
  var isExpanded = (0, _react.useMemo)(function () {
    if (multiple && Array.isArray(activeNames)) {
      return (0, _isInArray["default"])(activeNames, currentName);
    }

    return activeNames === currentName;
  }, [currentName, activeNames, multiple]);
  var shouldRenderChildren = (0, _react.useMemo)(function () {
    return isExpanded && !isLoading;
  }, [isLoading, isExpanded]);
  return /*#__PURE__*/_react["default"].createElement(_li["default"], {
    "data-id": "timeline-marker-li",
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_columnLeft["default"], null, /*#__PURE__*/_react["default"].createElement(_iconContainer["default"], null, /*#__PURE__*/_react["default"].createElement(_expandCollapseButton["default"], {
    isExpanded: isExpanded,
    isLoading: isLoading,
    onClick: handleToggleMarker
  }), icon)), /*#__PURE__*/_react["default"].createElement(_contentContainer["default"], null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_header["default"], null, /*#__PURE__*/_react["default"].createElement(_label["default"], null, label), /*#__PURE__*/_react["default"].createElement(_datetime["default"], null, datetime)), /*#__PURE__*/_react["default"].createElement(_description["default"], null, description)), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: shouldRenderChildren
  }, /*#__PURE__*/_react["default"].createElement(_body["default"], null, children))));
}

AccordionTimelineMarker.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  datetime: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  icon: _propTypes["default"].node,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  name: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool
};
AccordionTimelineMarker.defaultProps = {
  label: null,
  description: null,
  datetime: null,
  icon: /*#__PURE__*/_react["default"].createElement(_calendarIcon["default"], null),
  children: null,
  className: undefined,
  style: undefined,
  name: undefined,
  isLoading: false
};